import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';

@Injectable({
  providedIn: 'root',
})
export class DeletePromptService {
  constructor(private apiService: ApiService) {}

  deletarPrompt(idPrompt: number): Observable<any> {
    return this.apiService.delete('prompt', idPrompt);
  }
}
